export const STATS = [
  { value: '+200', label: 'Empresas atendidas' },
  { value: '+3000', label: 'Contratações realizadas' },
  { value: '95%', label: 'Taxa de assertividade' },
  { value: '72h', label: 'Tempo médio de contratação' },
];

export const CHALLENGES = [
  {
    icon: 'Clock',
    title: 'Processos seletivos lentos',
    desc: 'Vagas abertas por semanas ou meses, impactando a produtividade e gerando custos elevados para a empresa.',
  },
  {
    icon: 'UserX',
    title: 'Candidatos desalinhados',
    desc: 'Profissionais que não correspondem ao perfil técnico ou cultural da organização, resultando em contratações inadequadas.',
  },
  {
    icon: 'TrendingDown',
    title: 'Alta rotatividade',
    desc: 'Turnover elevado devido a contratações mal planejadas, gerando retrabalho e custos adicionais com novos processos.',
  },
];

export const SERVICES = [
  {
    icon: 'Target',
    title: 'Recrutamento especializado',
    desc: 'Identificamos e atraímos os melhores talentos do mercado, alinhados com as necessidades específicas da sua empresa.',
  },
  {
    icon: 'Filter',
    title: 'Triagem qualificada',
    desc: 'Avaliação criteriosa de candidatos através de entrevistas técnicas e comportamentais.',
  },
  {
    icon: 'Zap',
    title: 'Agilidade na entrega',
    desc: 'Processos otimizados que garantem candidatos qualificados em até 72 horas.',
  },
  {
    icon: 'Users',
    title: 'Perfis alinhados',
    desc: 'Matching preciso entre competências técnicas e fit cultural com sua organização.',
  },
];

export const WHY_CHOOSE = [
  { num: '01', title: 'Agilidade', desc: 'Processos otimizados que entregam resultados em até 72 horas, sem comprometer a qualidade da seleção.' },
  { num: '02', title: 'Assertividade', desc: 'Taxa de 95% de aprovação nas contratações, garantindo profissionais alinhados com suas necessidades.' },
  { num: '03', title: 'Atendimento consultivo', desc: 'Atendimento personalizado em todas as etapas, com comunicação transparente e suporte dedicado.' },
];

export const SPECIALTIES = [
  'Administrativo & Financeiro',
  'Comercial & Vendas',
  'Engenharia',
  'Industrial & Operações',
  'Logística & Supply Chain',
  'Recursos Humanos',
  'Tecnologia & TI',
  'Marketing & Comunicação',
  'Saúde & Farma',
];

export const MOCK_JOBS = [
  { id: 'j1', title: 'Analista de Marketing Digital', area: 'Marketing & Comunicação', location: 'São Paulo, SP', type: 'CLT', modality: 'Híbrido', salary: 'R$ 5.000 - R$ 7.000', description: 'Buscamos profissional para liderar campanhas de mídia paga e estratégias de SEO.', requirements: ['Graduação em Marketing ou áreas correlatas', 'Experiência mínima de 2 anos', 'Conhecimento em Google Ads e Meta Ads'], status: 'open', createdAt: '2025-07-01' },
  { id: 'j2', title: 'Desenvolvedor Full Stack', area: 'Tecnologia & TI', location: 'Remoto', type: 'PJ', modality: 'Remoto', salary: 'R$ 9.000 - R$ 13.000', description: 'Desenvolvimento de plataforma SaaS com React e Node.js.', requirements: ['React, Node.js, MongoDB', '3+ anos de experiência', 'Inglês intermediário'], status: 'open', createdAt: '2025-07-03' },
  { id: 'j3', title: 'Analista Financeiro Pleno', area: 'Administrativo & Financeiro', location: 'Campinas, SP', type: 'CLT', modality: 'Presencial', salary: 'R$ 6.500', description: 'Análise de fluxo de caixa, conciliação bancária e suporte ao planejamento financeiro.', requirements: ['Excel avançado', 'Experiência com SAP', 'Graduação em Ciências Contábeis'], status: 'open', createdAt: '2025-07-05' },
];

export const COMPANY_INFO = {
  name: 'HM Talent',
  ceo: 'Higor Monteiro',
  ceoTitle: 'CEO HM Talent | Consultor Estratégico de Recrutamento e Seleção',
  whatsapp: '5511920897014',
  whatsappGroup: 'https://chat.whatsapp.com/KwHinFwPNlaB8UjEvhZPeW',
  whatsappMsg: 'Olá! Gostaria de saber mais sobre os serviços da HM Talent.',
  email: 'higor@hmtalent.com.br',
  phone: '(11) 92089-7014',
  location: 'Mauá - SP | Atendimento em todo o território nacional',
  linkedinHigor: 'https://www.linkedin.com/in/higormonteiroh/',
};
